/**
 * Board D's „Do uzupełnienia" toggle (exercise-library R17): the movements added from Buddy's
 * proposals and not yet checked, out of the list the toolbar is narrowing.
 *
 * The count is of the list as the trainer sees it now — the scope, the search and the facets — so
 * pressing the toggle shows exactly that many rows, and a zero beside it means pressing shows none.
 */

export interface ReviewView<T> {
  /** The rows the table draws: all of them, or only the marked ones while the toggle is pressed. */
  readonly shown: readonly T[];
  /** How many of the list carry the mark: the toggle's figure. */
  readonly count: number;
}

export function reviewView<T extends { readonly needsReview: boolean }>(results: readonly T[], only: boolean): ReviewView<T> {
  const marked = results.filter((item) => item.needsReview);
  return { shown: only ? marked : results, count: marked.length };
}
